import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import reactT from '../../components/reactT';

function ShowAllModal(props) {
  const { children, filter, currentQuery, CurrentFacetsCounter } = props;
  const [show, setShow] = useState(false);
  const handleClose = () => {
    props.clearFilter();
    setShow(false);
  }
  const handleShow = (e) => {
    e.preventDefault();
    setShow(true);
  }

  const allAreNull =
    Object.values(children).every(value => {
      // 👇️ check for multiple conditions
      if (value === null || value === undefined || value === '') {
        return true;
      }
      return false;
    });

  return (
    <>
      <a href="!#" className='btn-sm p-0' onClick={handleShow}>
        {props.triggerLabel}
      </a>

      <Modal show={show} onHide={handleClose} dialogClassName="modal-md show-all-modal">
        <Modal.Header className="border-bottom-0">
          <Modal.Title as='h3'>{reactT('Search in') + ' ' + props.title}</Modal.Title>
          <button
            type="button"
            className="close"
            onClick={handleClose}
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          {filter}
        </Modal.Header>
        <div className='modal-applied-filters'>
          {currentQuery}
        </div>
        <Modal.Body className={allAreNull !== true && CurrentFacetsCounter >= 10 ? 'disabled' : ''}>
          {allAreNull !== true && CurrentFacetsCounter >= 10 ? <div className="alert alert-warning mt-0 sticky-top z-index-6 w-100 hint-message unlimited-message" role="alert">{reactT('You have selected the maximum number of filters for this search. Please deselect one or more filters to continue.')}</div> : ''}
          {allAreNull !== true ? children : <p>{reactT('No results found.')}</p>}
        </Modal.Body>
        <Modal.Footer className="align-items-center justify-content-between border-0 mb-md-4 pb-md-3 pt-md-3 mt-md-3">
          <button className={props.selectedCount > 0 ? 'btn btn-white m-0 px-0 border border-dark' : 'btn btn-white m-0 px-0 border border-dark disabled'} onClick={props.selectedCount > 0 ? props.onClear : null}>{reactT('Clear') + ' (' + props.selectedCount + ')'}</button>
          <button className="btn btn-secondary m-0 px-0 border border-secondary" onClick={handleClose}>{reactT('Apply')}</button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ShowAllModal;
